import { render, staticRenderFns } from "./ReviewsRatingMetric.vue?vue&type=template&id=ef614d82&scoped=true&"
import script from "./ReviewsRatingMetric.vue?vue&type=script&lang=js&"
export * from "./ReviewsRatingMetric.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsRatingMetric.vue?vue&type=style&index=0&id=ef614d82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef614d82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VSheet,VTooltip})
